var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-field",
    {
      staticClass: "full-width",
      attrs: { grouped: "", "group-multiline": "" },
    },
    [
      _c(
        "b-field",
        { staticClass: "control", attrs: { expanded: "" } },
        [
          _c("b-pagination", {
            attrs: {
              rounded: "",
              total: _vm.total,
              "range-before": 2,
              "range-after": 2,
              order: "is-centered",
              size: _vm.size,
              "per-page": _vm.documentsPerPage,
            },
            on: {
              change: function ($event) {
                return _vm.$emit("update:pageNumber", $event)
              },
            },
            model: {
              value: _vm.pNumber,
              callback: function ($$v) {
                _vm.pNumber = $$v
              },
              expression: "pNumber",
            },
          }),
        ],
        1
      ),
      _c(
        "b-field",
        { staticClass: "control" },
        [
          _c(
            "b-dropdown",
            {
              attrs: {
                position: "is-bottom-left",
                "append-to-body": "",
                "aria-role": "list",
                "mobile-modal": false,
              },
              on: {
                input: function ($event) {
                  return _vm.$emit("update:documentsPerPage", $event)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "trigger",
                  fn: function ({ active }) {
                    return [
                      _c("b-button", {
                        attrs: {
                          type: "is-primary",
                          size: "is-small",
                          label: `${_vm.itemsName} por página: ${_vm.documentsPerPage}`,
                          rounded: "",
                          "icon-right": active
                            ? "fa fa-chevron-up"
                            : "fa fa-chevron-down",
                        },
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                          },
                        },
                      }),
                    ]
                  },
                },
              ]),
              model: {
                value: _vm.docsPerPage,
                callback: function ($$v) {
                  _vm.docsPerPage = $$v
                },
                expression: "docsPerPage",
              },
            },
            _vm._l(_vm.documentsPerPageOptions, function (option) {
              return _c(
                "b-dropdown-item",
                {
                  key: option,
                  attrs: { value: option, "aria-role": "listitem" },
                },
                [_c("span", [_vm._v(_vm._s(option))])]
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }